module.exports = __webpack_public_path__ + "img/canot-dots-1.f9679010.png";